export enum SideCartAppDataHook {
  root = 'SideCartAppDataHook.root',
}

export interface SideCartProps {
  dir: string;
}
